module.exports = __webpack_public_path__ + "img/option-route.16b7ebfd.png";